import axios from 'axios';
import config from './config/appConstants';

const { API_ROUTE, API_TOKEN, PAYMENT_URL } = config;

const apiGateWay = axios.create({
	baseURL: API_ROUTE
});

apiGateWay.interceptors.response.use(
	(res) => {
		if (res.data && res.data.statusCode === 401) {
			sessionStorage.clear();
			window.location.href = '/';
		}
		return res;
	},
	(res) => res
);

apiGateWay.interceptors.request.use((config) => {
	try {
		const tempConfig = {
			...config,
			headers: {
				...config.headers,
				'X-Requested-With': 'XMLHttpRequest',
				AuthToken: `Bearer ${API_TOKEN}`,
			},
		};
		return tempConfig;
	} catch (error) {
		console.error(`apiGateWay.interceptors.request Error : -`, error);
	}
});

export const paymentApiGateway = axios.create({
	baseURL: PAYMENT_URL
});

paymentApiGateway.interceptors.request.use((config) => {
	console.log(`paymentApiGateway.interceptors.request config : -`, config, PAYMENT_URL);
	const authToken = sessionStorage.getItem("paymentToken");
	if (authToken) {
		config.headers['Authorization'] = `Bearer ${authToken}`;
	};

	return config;
}, (error) => {	
	console.error(`paymentApiGateway.interceptors.request Error : -`, error);
	return Promise.reject(error);
});

export default apiGateWay;
